import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import AutoSuggest from "../../../../../../../components/Form/AutoSuggest";
import SkeletonComponent from "../../../../../../../components/Generic/Skeleton";
import { Transshipment } from "../../../../../../../models/transshipment";
import { User } from "../../../../../../../models/user";
import { ModalBody } from "../../ChangeTransshipmentAssigneeModal/styles";
import { OptionSubtitle, OptionTitle, OptionWraper } from "./style";

interface ITransshipmentAssigneeComponent {
  transshipment?: Transshipment;
  leaders?: User[];
  isLeadersLoading: boolean;
  handleNewTransshipmentLeaderId: (leaderId: number | null) => void;
}

export const TransshipmentAssigneeComponent = ({
  transshipment,
  leaders,
  isLeadersLoading,
  handleNewTransshipmentLeaderId,
}: ITransshipmentAssigneeComponent) => {
  const { t: translate } = useTranslation();

  const [selectedLeader, setSelectedLeader] = useState<User | null>(null);

  useEffect(() => {
    if (transshipment?.leader) {
      setSelectedLeader(transshipment.leader);
    }
  }, [transshipment?.leader]);

  const handleChangeLeader = (leader: User | null) => {
    setSelectedLeader(leader);

    if (leader?.id !== undefined) {
      handleNewTransshipmentLeaderId(leader.id);
    } else {
      handleNewTransshipmentLeaderId(null);
    }
  };

  const getLeaderDescription = (leader?: User | null) => {
    if (leader) {
      return leader?.fullName || "";
    }
    return "";
  };

  return (
    <ModalBody>
      <SkeletonComponent isLoading={isLeadersLoading} isInput>
        <AutoSuggest
          name="assigned"
          label={translate("assignedTo")}
          placeholder={translate("selectAPerson")}
          getOptionLabel={(leader?: User) => {
            if (leader) return `${leader?.fullName}` || "";

            return "";
          }}
          getOptionSelected={(option: User, value: User) => option?.id === value?.id}
          inputValue={getLeaderDescription(selectedLeader)}
          value={selectedLeader}
          onChange={(leader: User | null) => {
            handleChangeLeader(leader);
          }}
          options={leaders && leaders.length > 0 ? leaders : []}
          renderOption={(props, option) => (
            <div {...props}>
              <OptionWraper>
                <OptionTitle>{option?.fullName ?? ""}</OptionTitle>
                <OptionSubtitle>{option?.email ?? ""}</OptionSubtitle>
              </OptionWraper>
            </div>
          )}
        />
      </SkeletonComponent>
    </ModalBody>
  );
};
